import { resolvePublicProposalCtaUrl } from './defaultPublicProposalCtaUrl';

const normalizeParticipants = (activity = {}) => {
  const fromObject = activity.participants;
  if (fromObject && typeof fromObject === 'object') {
    return {
      min:
        fromObject.min === null || fromObject.min === undefined
          ? null
          : Number(fromObject.min),
      max:
        fromObject.max === null || fromObject.max === undefined
          ? null
          : Number(fromObject.max),
    };
  }

  return {
    min:
      activity.participantsMin === null ||
      activity.participantsMin === undefined
        ? null
        : Number(activity.participantsMin),
    max:
      activity.participantsMax === null ||
      activity.participantsMax === undefined
        ? null
        : Number(activity.participantsMax),
  };
};

const normalizeArray = (value) => {
  if (Array.isArray(value)) {
    return value
      .map((entry) => (typeof entry === 'string' ? entry.trim() : entry))
      .filter(Boolean);
  }
  if (typeof value === 'string' && value.trim()) {
    return value
      .split(',')
      .map((entry) => entry.trim())
      .filter(Boolean);
  }
  return [];
};
const normalizeDuration = (durations, duration) => {
  if (Array.isArray(durations)) return durations.filter(Boolean);
  if (typeof durations === 'string' && durations.trim())
    return [durations.trim()];
  if (Array.isArray(duration)) return duration.filter(Boolean);
  if (typeof duration === 'string' && duration.trim()) return [duration.trim()];
  return [];
};

const normalizePricing = (activity = {}) => {
  const rules = Array.isArray(activity.pricing) ? activity.pricing : [];
  const normalizedRules = rules
    .map((rule) => {
      if (!rule || typeof rule !== 'object') return null;
      return {
        mode: rule.mode || 'per_incontro',
        label: rule.label || '',
        amount:
          rule.amount === null || rule.amount === undefined
            ? null
            : Number(rule.amount),
        unitAmount:
          rule.unitAmount === null || rule.unitAmount === undefined
            ? null
            : Number(rule.unitAmount),
        packageMeetings:
          rule.packageMeetings === null || rule.packageMeetings === undefined
            ? null
            : Number(rule.packageMeetings),
        extraMeetingAmount:
          rule.extraMeetingAmount === null ||
          rule.extraMeetingAmount === undefined
            ? null
            : Number(rule.extraMeetingAmount),
        minParticipants:
          rule.minParticipants === null || rule.minParticipants === undefined
            ? null
            : Number(rule.minParticipants),
        maxParticipants:
          rule.maxParticipants === null || rule.maxParticipants === undefined
            ? null
            : Number(rule.maxParticipants),
        notes: rule.notes || '',
      };
    })
    .filter(Boolean);

  const firstRule = normalizedRules[0];
  const summary = firstRule
    ? firstRule.mode === 'per_persona'
      ? `da ${firstRule.unitAmount || firstRule.amount || 0} EUR/persona`
      : firstRule.mode === 'per_gita'
        ? `da ${firstRule.amount || firstRule.unitAmount || 0} EUR/gita`
        : `da ${firstRule.amount || firstRule.unitAmount || 0} EUR`
    : activity.priceRange || '';

  return { rules: normalizedRules, summary };
};

export const resolvePublicProposal = (proposal = {}) => {
  const activity =
    proposal.activity && typeof proposal.activity === 'object'
      ? proposal.activity
      : {};

  return {
    title: proposal.titolo?.trim() || activity.title || '',
    shortDescription:
      proposal.descrizioneBreve?.trim() || activity.shortDescription || '',
    fullDescription:
      proposal.descrizioneCompleta?.trim() || activity.fullDescription || '',
    category: activity.category || null,
    target: normalizeArray(activity.target),
    duration: normalizeDuration(activity.durations, activity.duration),
    location: activity.location || '',
    locationLabel: activity.locationLabel || '',
    participants: normalizeParticipants(activity),
    priceRange: activity.priceRange || '',
    pricing: normalizePricing(activity),
    objectives: normalizeArray(activity.objectives),
    keywords: normalizeArray(activity.keywords),
    skills: normalizeArray(activity.skills),
    benefits: normalizeArray(activity.benefits),
    period: normalizeArray(activity.period),
    materialsIncluded: Boolean(activity.materialsIncluded),
    materials: activity.materials || '',
    experienceType: activity.experienceType || null,
    difficulty: activity.difficulty || null,
    level: activity.level || null,
    format: activity.format || null,
    ageRange: activity.ageRange || null,
    parentsRequired: Boolean(activity.parentsRequired),
    strollerFriendly: Boolean(activity.strollerFriendly),
    whatToBring: activity.whatToBring || '',
    safetyNotes: activity.safetyNotes || '',
    weatherFallback: activity.weatherFallback || '',
    privateGroupAvailable: Boolean(activity.privateGroupAvailable),
    bookingRequired: Boolean(activity.bookingRequired),
    accessibility: activity.accessibility || '',
    notes: activity.notes || '',
    autonomyLevel: activity.autonomyLevel || null,
    activityType: activity.activityType || null,
    socialValue: activity.socialValue || null,
    parentalConsentRequired: Boolean(activity.parentalConsentRequired),
    notesForParents: activity.notesForParents || '',
    publicSubtype: proposal.publicSubtype || null,
    cta: {
      label: proposal.ctaLabel || 'Scopri di piu',
      url: resolvePublicProposalCtaUrl(proposal),
    },
  };
};
